<template>
  <div class="news-detail-base">
    <h1>{{newsData.title}}</h1>
    <span class="news-datetime">{{newsData.opened_at | formatDatetime}}</span>
    <div class="wrap">
      <div class="news-body" v-html="newsData.content"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NewsDetail',
  props: {
    newsListTitle: {
      type: String,
      default: ''
    },
    newsData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  filters: {
    formatDatetime(val){
      const dt = new moment(val)
      if(dt.isValid()){
        return `${dt.format('YYYY年MM月DD日 H時mm分')}`
      }
      return ''
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';
$col_borders: #e3e3e3;
.news-detail-base {
  color: #303030;
  padding: 32px 24px 40px;
  h1 {
    font-size: 18px;
    @include mq('w580'){
      font-size: 20px;
    }
    margin: 0 0 8px;
    //text-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  }
  .news-datetime {
    display: block;
    font-size: 12px;
    margin-bottom: 8px;
    padding: 0 0 4px;
  }
  .wrap {
    border: 1px solid $col_borders;
    background: rgba(255, 255, 255, 0.7);
    padding: 24px 16px;
    border-radius: 3px;
  }
}

.lbl-new {
  display: inline-block;
  color: white;
  background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
  padding: 4px 6px;
  font-size: 10px;
  border-radius: 5px;
  font-weight: bold;
  margin-right: 8px;
  line-height: 1;
}

/deep/ {
  .news-body {
    h1,h2,h3,h4,h5,h6 {
      margin: 0 0 16px;
      font-weight: bold;
      line-height: 1;
    }
    strong, b {
      font-weight: bold;
    }
    .btn {
      display: flex;
      background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
      color: white;
      justify-content: center;
      align-items: center;
      width: 300px;
      border-radius: 30px;
      padding: 8px 0;
      text-align: center;
      font-weight: bold;
      text-decoration: none;
      margin: 8px auto;
      line-height: 1.4;
      height: 54px;
      max-height: 60px;
      cursor: pointer;
      &.ghost {

      }
    }
    img {
      display: block;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/News/NewsDetail.vue